import { render, staticRenderFns } from "./LegalCaseCard.vue?vue&type=template&id=568d99da&scoped=true&"
import script from "./LegalCaseCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LegalCaseCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LegalCaseCard.vue?vue&type=style&index=0&id=568d99da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d99da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568d99da')) {
      api.createRecord('568d99da', component.options)
    } else {
      api.reload('568d99da', component.options)
    }
    module.hot.accept("./LegalCaseCard.vue?vue&type=template&id=568d99da&scoped=true&", function () {
      api.rerender('568d99da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LegalCaseCard/components/LegalCaseCard.vue"
export default component.exports